import { Controller } from "@hotwired/stimulus"

// Handles widget loading states - shows skeleton while loading, then fades in content
export default class extends Controller {
  static targets = ["skeleton", "content"]

  connect() {
    // When content loads, hide skeleton and show content
    if (this.hasContentTarget) {
      this.showContent()
    }
  }

  showContent() {
    // Hide skeleton
    if (this.hasSkeletonTarget) {
      this.skeletonTarget.style.display = "none"
    }

    // Show and fade in content
    if (this.hasContentTarget) {
      this.contentTarget.style.opacity = "0"
      this.contentTarget.style.display = "block"

      requestAnimationFrame(() => {
        this.contentTarget.style.transition = "opacity 300ms ease-in"
        this.contentTarget.style.opacity = "1"
      })
    }
  }
}
